<script>
  import { FormEditor } from "@bpmn-io/form-js-editor";
  import { onMount } from "svelte";
  import Header from "lib/components/Header.svelte";
  import { useNavigate } from "svelte-navigator";
  import { ROUTES } from "@utils/routes.js";
  import { useUrlParams } from "@stores/urlStore.js";
  import "./form-js.css";
  import "./form-js-editor.css";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import Modal from "lib/components/Modal.svelte";
  import { fly } from "svelte/transition";
  import {
    Modal as DangerModal,
    MultiSelect,
    Checkbox,
    DatePicker,
    DatePickerInput,
    TimePicker,
    ToastNotification,
    Loading,
    DataTable,
    Toolbar,
    ToolbarSearch,
    ToolbarContent,
    NumberInput,
  } from "carbon-components-svelte";
  import {
    TextInput,
    TextArea,
    Button,
    Select,
    SelectItem,
  } from "paxray-components-svelte";

  import {
    ARROW_LEFT_ICON,
    ARROW_RIGHT_ICON,
    CHECK_ICON,
    CLOSE_ICON,
    EDIT_ICON,
    PLUS_ICON,
    TRASH_ICON,
  } from "@utils/icons.js";

  const navigate = useNavigate();
  const urlParams = useUrlParams();
  const initialParams = new URLSearchParams(window.location.search);
  const prefilledProjectName = initialParams.get("projectName") || "";
  const requestedSection = initialParams.get("section") || "";
  const section = ["scope", "participants", "settings"].includes(
    requestedSection,
  )
    ? requestedSection
    : "";
  const prefilledDepartments = (() => {
    try {
      return JSON.parse(initialParams.get("departments") || "[]");
    } catch {
      return [];
    }
  })();
  let projectPrefillApplied = false;
  let edit = false;
  $: ({ survey } = $urlParams);
  $: edit = Boolean(survey);
  $: sectionMode = Boolean(edit && section);
  $: sectionStartStep =
    section === "participants" ? 4 : section === "settings" ? 5 : 0;
  $: sectionEndStep =
    section === "scope" ? 3 : section === "participants" ? 4 : 5;
  $: hasSectionNext = sectionMode
    ? (section === "scope" && step < sectionEndStep) ||
      (section === "participants" &&
        areaStep < selectedBusinessUnits.length - 1)
    : step < totalSteps;
  $: hasSectionPrevious = sectionMode
    ? (section === "scope" && step > sectionStartStep) ||
      (section === "participants" && areaStep > 0)
    : step > 0;
  $: sectionBreadcrumb =
    section === "scope"
      ? "Configure Scope"
      : section === "participants"
        ? "Select Participants"
        : section === "settings"
          ? "Survey Settings"
          : "";
  let container;
  let formuploader;
  let formName = "New Form";
  let formEditor;
  const requestedStep = Number(initialParams.get("step"));
  const targetStep =
    Number.isInteger(requestedStep) && requestedStep >= 0 && requestedStep <= 5
      ? requestedStep
      : 0;
  let step = section ? 0 : targetStep;
  let areaStep = 0;
  let totalSteps = 6;
  let user = localStorage.getItem("username") || "User";
  let selectedBusinessUnits = [];
  let selectedAreas = [];
  let selectedDepartments = [];
  let selectedTasks = [];
  let selectedPeople = [];
  let loadingSurvey = true;
  let loading = true;

  let id = "";
  let openDangerModal = false;
  let openOptionDangerModal = false;
  let openModalNew = false;
  let openSendModal = false;
  let selectedOption;
  let newValue = "";
  let allowCusomTask = false;
  let disableNext = false;
  let disableSave = false;
  let multiselectItems = [];
  let selectedItems = [];
  let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  const defaultEndDate = new Date(currentDate);
  defaultEndDate.setDate(currentDate.getDate() + 7);
  const defaultStartDate = new Date(currentDate);
  defaultStartDate.setDate(currentDate.getDate() + 1);
  let defaultName = `Survey ${currentDate.toLocaleDateString("en-GB").split("/").join("-")}`;
  let settings = {
    surveyName: defaultName,
    startDate: defaultStartDate
      .toLocaleDateString("en-GB")
      .split("/")
      .join("-"),
    startTime: "00:00",
    endDate: defaultEndDate.toLocaleDateString("en-GB").split("/").join("-"),
    endTime: "00:00",
    reminder_days: 1,
    reminder2_days: 2,
    objective: [],
    language: "en",
    contactPersonName: "",
    contactPersonEmail: "",
    signature: "",
  };
  let contactPerson = false;
  let enableFirstReminder = true;
  let enableSecondReminder = true;
  let openToast = false;

  let options = [];

  let areas;
  let businessUnits;
  let departments;
  let tasks;
  let selectModalOptions = [];
  let upperLevel;
  let newUser = { email: "", first_name: "", last_name: "" };
  let baseHeaders = [
    { key: "email", value: "E-Mail" },
    { key: "department", value: "Department" },
  ];
  let usersPerDepartment = [];
  let selectedUsers = [];
  let usersFiltered = [];
  let tableFilter = "";
  let selectedDepartmentFilters = [];
  let departmentFilterOptions = [];
  let selectedUsersIds = [];
  let errorToastMessage = "Start date must be in the future";
  let invalidDates = false;
  let invalidSettingsText = "";

  let titles = [
    {
      head: `Start`,
      type: "business unit",
      title: `Hello ${user}`,
      subtitle: `For which business unit would you like to receive information?`,
    },
    {
      head: `Department Selection`,
      type: "department",
      title: `Department Selection`,
      subtitle: `For which departments would you like to receive information?`,
    },
    {
      head: `Area Selection`,
      type: "area",
      title: `Area Selection`,
      subtitle: `For which areas would you like to receive information?`,
    },
    {
      head: `Task Selection`,
      type: "task",
      title: `Task Selection`,
      subtitle: `Do you want to give your survey participant some tasks of interest already?`,
    },
    {
      head: `User Selection in business unit`,
      type: "department",
      title: `User Selection in business unit`,
      subtitle: `Who should take part in your survey? Please select at least 3 people per department to continue`,
    },
    {
      head: `Survey Settings`,
      type: "survey",
      title: `Survey Settings`,
      subtitle: `Final details to complete the survey`,
    },
    {
      head: `Done`,
      type: "submit",
      title: `Your survey is almost ready, please confirm to create it!`,
      subtitle:
        "The invitations to the survey will be automatically sent out in regard to your set starting time",
    },
  ];

  let objectives;
  let kpiDropdownSelection = [];
  $: selectedObjectives = (objectives || []).filter((objective) =>
    settings.objective.includes(objective.id),
  );
  $: availableObjectives = (objectives || []).filter(
    (objective) => !settings.objective.includes(objective.id),
  );

  let reminderOptions = [
    { id: "1 day reminder", text: "1 day reminder" },
    { id: "2 days reminder", text: "2 day reminder" },
  ];

  $: if (!loading) setMultiselectItems(step);
  $: setSelectedItems(step, areaStep);
  $: setSelectedItemsStep(selectedItems);
  $: setDefaultSurveyName(selectedBusinessUnits);
  $: setOptions(selectedItems);
  $: departmentFilterOptions = Array.from(
    new Map(
      usersPerDepartment.map((user) => [
        user.department.id,
        { id: user.department.id, text: user.department.name },
      ]),
    ).values(),
  ).sort((a, b) => a.text.localeCompare(b.text));
  $: aplyUsersFilter(tableFilter, selectedDepartmentFilters);
  $: updateSelectedUsers(selectedUsersIds);

  $: if (businessUnits && departments && areas && tasks) loading = false;
  $: if (!loading && edit && loadingSurvey) getSurveyData();
  $: if (!loading && !edit) {
    applyProjectPrefill();
    loadingSurvey = false;
  }

  $: disableSave =
    (step !== 4 && !newValue) ||
    (step === 4 &&
      !(
        isValidEmail(newUser.email) &&
        newUser.first_name &&
        newUser.last_name
      ));

  $: disableNext =
    (step === 0 && selectedItems[0] === " ") ||
    (step < 4 && selectedItems.length === 0) ||
    (step === 4 && disabledNextButtonNoEnoughUsers(selectedUsers)) ||
    (step === 5 &&
      (settings.objective.length === 0 ||
        invalidDates ||
        (!settings.reminder_days && enableFirstReminder) ||
        (!settings.reminder2_days && enableSecondReminder) ||
        (contactPerson &&
          (!settings.contactPersonName ||
            !isValidEmail(settings.contactPersonEmail))) ||
        !settings.signature));

  $: invalidDates = checkCorrectDates(settings.startDate, settings.endDate);
  $: setInvalidSettingsText(settings, contactPerson);

  function setInvalidSettingsText(settings, contactPerson) {
    let arrayText = [];
    invalidSettingsText = "";
    if (settings.objective.length === 0) {
      arrayText.push("select at least 1 primary objective");
    }
    if (invalidDates) {
      arrayText.push("set valid start and end dates");
    }
    if (!settings.reminder_days && enableFirstReminder) {
      arrayText.push("set days for the first reminder");
    }
    if (!settings.reminder2_days && enableSecondReminder) {
      arrayText.push("set days for the second reminder");
    }
    if (contactPerson) {
      if (!settings.contactPersonName) {
        arrayText.push("add contact person name");
      }
      if (!isValidEmail(settings.contactPersonEmail)) {
        arrayText.push("add a valid contact person email");
      }
    }
    if (!settings.signature) {
      arrayText.push("add a signature");
    }
    if (arrayText.length === 1)
      invalidSettingsText = "Please " + arrayText[0] + ".";
    else if (arrayText.length > 1)
      invalidSettingsText =
        "Please " +
        arrayText.slice(0, -1).join(", ") +
        " and " +
        arrayText.slice(-1) +
        ".";
  }

  function checkCorrectDates(startDate, endDate) {
    const [startDay, startMonth, startYear] = startDate.split("-");
    const [endDay, endMonth, endYear] = endDate.split("-");
    const startDateTime = new Date(`${startYear}-${startMonth}-${startDay}`);
    const endDateTime = new Date(`${endYear}-${endMonth}-${endDay}`);
    const isStartInFuture = edit || startDateTime >= currentDate;
    const isEndAfterStart = startDateTime < endDateTime;

    errorToastMessage = !isStartInFuture
      ? "Start date must be in the future"
      : !isEndAfterStart
        ? "End date must be after start date"
        : "";

    let invalid = !(isStartInFuture && isEndAfterStart);
    openToast = invalid;
    return invalid;
  }

  function updateSelectedUsers(selectedUsersIds) {
    selectedUsers.forEach(
      (user) => (user.selected = selectedUsersIds.includes(user.id)),
    );
    selectedUsers = [...selectedUsers];
  }

  function setSelectModalOptions() {
    selectModalOptions = [];

    if (step === 1)
      selectModalOptions = businessUnits.filter((bu) =>
        selectedBusinessUnits.includes(bu.id),
      );
    else if (step === 2)
      selectModalOptions = departments.filter((depts) =>
        selectedDepartments.includes(depts.id),
      );
    else if (step === 3)
      selectModalOptions = areas.filter((areas) =>
        selectedAreas.includes(areas.id),
      );
    else if (step === 4)
      selectModalOptions = departments.filter(
        (depts) =>
          selectedDepartments.includes(depts.id) &&
          businessUnits.find((a) => a.id === selectedBusinessUnits[areaStep])
            .id === depts.business_unit.id,
      );
    else {
      selectModalOptions = [];
    }

    upperLevel = selectModalOptions[0]?.id || "";
  }

  function aplyUsersFilter(tableFilter, departmentFilters) {
    const query = tableFilter.trim().toLowerCase();
    usersFiltered = usersPerDepartment.filter((user) => {
      const matchesSearch =
        !query ||
        user.email.toLowerCase().includes(query) ||
        user.department.name.toLowerCase().includes(query);
      const matchesDepartment =
        departmentFilters.length === 0 ||
        departmentFilters.includes(user.department.id);
      return matchesSearch && matchesDepartment;
    });
  }

  function selectedNewPreset(id) {
    // if (step === 0) selectedBusinessUnits = [...selectedBusinessUnits, id];
    // else if (step === 1) selectedDepartments = [...selectedDepartments, id];
    if (step === 0) selectedBusinessUnits[0] = id;
    //else if (step === 1) selectedDepartments[0] = id;
    else if (step === 1) selectedDepartments = [...selectedDepartments, id];
    else if (step === 2) selectedAreas = [...selectedAreas, id];
    else if (step === 3) selectedTasks = [...selectedTasks, id];
    setSelectedItems(step, areaStep);
  }

  function createNewUser() {
    fetchWithSession("/api/knextractor/users", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: newUser.email,
        first_name: newUser.first_name,
        last_name: newUser.last_name,
        department: upperLevel,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.id) {
          newUser = { email: "", first_name: "", last_name: "" };

          getDepartments().then(() => {
            getUsersPerDepartment();
          });
        }
        openModalNew = false;
      });
  }

  function newPreset() {
    let body = { name: newValue };
    if (titles[step]?.type !== "business unit")
      body[titles[step - 1]?.type.replace(" ", "_")] = upperLevel;
    const typeName = `${titles[step]?.type.replace(" ", "-")}s`;

    fetchWithSession(`/api/knextractor/${typeName}`, {
      method: "POST",
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          return;
        }
        newValue = "";
        updatePresets();
        selectedNewPreset(data.data.id);
        openModalNew = false;
      });
  }
  function setOptions(selectedItems) {
    options = [];
    if (step === 0) {
      selectedItems.forEach((item) => {
        if (businessUnits.some((a) => a.id === item))
          options.push(businessUnits.find((a) => a.id === item));
      });
    } else if (step === 1) {
      selectedItems.forEach((item) => {
        if (departments.some((a) => a.id === item))
          options.push(departments.find((a) => a.id === item));
      });
    } else if (step === 2) {
      selectedItems.forEach((item) => {
        if (areas.some((a) => a.id === item))
          options.push(areas.find((a) => a.id === item));
      });
    } else if (step === 3) {
      selectedItems.forEach((item) => {
        if (tasks.some((a) => a.id === item))
          options.push(tasks.find((a) => a.id === item));
      });
    } else if (step === 4) {
      getUsersPerDepartment();
    }
  }

  function setDefaultSurveyName(selectedBusinessUnits) {
    if (!settings.surveyName || settings.surveyName.startsWith(defaultName)) {
      if (selectedBusinessUnits.length === 0) {
        settings.surveyName = defaultName;
      } else {
        let businessUnitsText = businessUnits
          .filter((businessUnit) =>
            selectedBusinessUnits.includes(businessUnit.id),
          )
          .map((businessUnit) => businessUnit.text)
          .join(", ");
        settings.surveyName = `${defaultName}  ${businessUnitsText}`;
      }
    }
  }

  function setMultiselectItems(step) {
    if (step === 0) {
      multiselectItems = businessUnits.sort((a, b) =>
        a.text.localeCompare(b.text),
      );
    } else if (step === 1) {
      multiselectItems = departments
        .filter((department) =>
          selectedBusinessUnits.includes(department.business_unit.id),
        )
        .sort((a, b) => a.text.localeCompare(b.text));
      selectedDepartments = selectedDepartments.filter((department) =>
        multiselectItems.some((item) => item.id === department),
      );
    } else if (step === 2) {
      multiselectItems = areas
        .filter((area) => selectedDepartments.includes(area.department.id))
        .sort((a, b) => a.text.localeCompare(b.text));
      selectedAreas = selectedAreas.filter((area) =>
        multiselectItems.some((item) => item.id === area),
      );
    } else if (step === 3) {
      multiselectItems = tasks
        .filter((task) => selectedAreas.includes(task.area.id))
        .sort((a, b) => a.text.localeCompare(b.text));
      selectedTasks = selectedTasks.filter((task) =>
        multiselectItems.some((item) => item.id === task),
      );
    } else if (step === 4) {
      multiselectItems = departments.filter((department) =>
        selectedBusinessUnits.includes(department.business_unit.id),
      );
    }
  }
  function setSelectedItems(step, areaStep) {
    if (step === 0) selectedItems = selectedBusinessUnits;
    else if (step === 1) selectedItems = selectedDepartments;
    else if (step === 2) selectedItems = selectedAreas;
    else if (step === 3) selectedItems = selectedTasks;
    else if (step === 4) {
      selectedItems = [];
    }
  }

  function setSelectedItemsStep(selectedItems) {
    if (step === 0) selectedBusinessUnits = selectedItems;
    else if (step === 1) selectedDepartments = selectedItems;
    else if (step === 2) selectedAreas = selectedItems;
    else if (step === 3) selectedTasks = selectedItems;
  }

  function disabledNextButtonNoEnoughUsers(selectedUsers) {
    let disabled = false;

    let departmentsByBusinessUnits = selectedDepartments.filter((department) =>
      businessUnits
        .find(
          (businessUnit) => businessUnit.id === selectedBusinessUnits[areaStep],
        )
        .departments.some((BUdept) => BUdept.id === department),
    );

    departmentsByBusinessUnits.forEach((department) => {
      let usersToSendMail = selectedUsers.filter(
        (user) => user.department === department && user.selected,
      );
      if (usersToSendMail.length < 3) {
        disabled = true;
        return;
      }
    });
    return disabled;
  }

  function getUsersPerDepartment() {
    usersPerDepartment = [];
    const departmentsPeople = departments.filter(
      (department) =>
        selectedDepartments.includes(department.id) &&
        businessUnits.find((a) => a.id === selectedBusinessUnits[areaStep])
          .id === department.business_unit.id,
    );

    departmentsPeople.forEach((department) =>
      department.users.forEach((user) => {
        if (
          !selectedUsers.find((selectedUser) => selectedUser.id === user.id)
        ) {
          if (!selectedUsersIds.includes(user.id))
            selectedUsersIds.push(user.id);
          selectedUsers = [
            ...selectedUsers,
            {
              id: user.id,
              selected: true,
              department: department.id,
            },
          ];
        }
        usersPerDepartment.push({
          email: user.email,
          id: user.id,
          department: { name: department.text, id: department.id },
        });
      }),
    );
    usersPerDepartment = usersPerDepartment.filter((user) =>
      selectedDepartments.some((dept) => dept === user.department.id),
    );

    usersPerDepartment = [...usersPerDepartment];
    usersFiltered = usersPerDepartment;
    tableFilter = "";
    selectedDepartmentFilters = [];
  }

  function calculateSettingsDate(dateTime) {
    let [date, time] = dateTime.replace(":00+00:00", "").split("T");
    const [year, month, day] = date.split("-");
    date = new Date(year, month - 1, day)
      .toLocaleDateString("en-GB")
      .split("/")
      .join("-");
    return [date, time];
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // function calculateDateToSend(date, time) {
  //   const [day, month, year] = date.split("-");
  //   const formatedData = `${year}-${month}-${day}T${time}:00Z`;
  //   return formatedData;
  // }

  function calculateDateToSend(date) {
    const [day, month, year] = date.split("-");
    const formatedData = `${year}-${month}-${day}`;
    return formatedData;
  }

  function progressRoute() {
    return `${ROUTES.knex.potentialScope.dashboard}?survey=${survey}`;
  }

  async function saveSurvey(returnToProgress = false) {
    let surveyPayload = {
      name: settings.surveyName,
      tasks: selectedTasks,
      start_date: calculateDateToSend(settings.startDate),
      end_date: calculateDateToSend(settings.endDate),
      reminder_days: enableFirstReminder ? settings.reminder_days : null,
      reminder2_days: enableSecondReminder ? settings.reminder2_days : null,
      enabled: true,
      questions: settings.objective,
      custom_tasks: allowCusomTask,
      language: settings.language,
      users: selectedUsers
        .filter(
          (user) =>
            selectedDepartments.includes(user.department) && user.selected,
        )
        .map((user) => user.id),
      email_signature: settings.signature,
      contact_person: contactPerson ? settings.contactPersonName : null,
      contact_person_email: contactPerson ? settings.contactPersonEmail : null,
    };
    let method = edit ? "PATCH" : "POST";

    const response = await fetchWithSession(
      `/api/knextractor/surveys${edit ? "/" + survey : ""}`,
      {
        method: method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(surveyPayload),
      },
    );
    const data = await response.json();
    if (!response.ok || data.error) {
      return;
    }
    if (section === "settings" && survey) {
      await fetchWithSession(
        `/api/knextractor/surveys/${survey}/invitation-schedule`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "start" }),
        },
      );
    }
    if (returnToProgress) {
      window.location.assign(progressRoute());
      return;
    }
    openSendModal = true;
  }

  function loadDateTimes(loadedDate) {
    const [year, month, day] = loadedDate.split("-");
    return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}`;
  }
  function loadUsers(usersToLoad) {
    selectedUsers = [];
    let usersByDept = departments
      .filter((department) => selectedDepartments.includes(department.id))
      .map((department) => {
        return { department: department.id, users: department.users };
      });
    usersByDept.forEach((dept) =>
      dept.users.forEach((user) => {
        if (usersToLoad.some((userToLoad) => userToLoad.user.id === user.id))
          selectedUsersIds.push(user.id);
        selectedUsers.push({
          id: user.id,
          department: dept.department,
          selected: usersToLoad.some(
            (userToLoad) => userToLoad.user.id === user.id,
          ),
        });
      }),
    );
  }
  function getSurveyData() {
    fetchWithSession(`/api/knextractor/surveys/${survey}`)
      .then((response) => response.json())
      .then((data) => {
        settings.surveyName = data.name;
        loadSelectedAreas(data.survey_tasks);

        allowCusomTask = data.custom_tasks;
        if (!data.reminder_days) enableFirstReminder = false;
        if (!data.reminder2_days) enableSecondReminder = false;
        settings.reminder_days = data.reminder_days;
        settings.reminder2_days = data.reminder2_days;
        settings.objective = data.questions;
        settings.language = data.language || "en";
        settings.startDate = loadDateTimes(data.start_date);
        settings.endDate = loadDateTimes(data.end_date);
        settings.signature = data.email_signature;
        settings.contactPersonName = data.contact_person || "";
        settings.contactPersonEmail = data.contact_person_email || "";
        if (data.contact_person || data.contact_person_email)
          contactPerson = true;
        settings = { ...settings };
        setSelectedItems(step, areaStep);
        loadUsers(data.survey_users);
        if (section) step = targetStep;
        loadingSurvey = false;
      });
  }

  function loadSelectedAreas(loadedTasks) {
    selectedTasks = loadedTasks.map((task) => task.task.id);
    selectedAreas = Array.from(
      new Set(
        tasks
          .filter((task) => selectedTasks.includes(task.id))
          .map((tasks) => tasks.area.id),
      ),
    );
    selectedDepartments = Array.from(
      new Set(
        areas
          .filter((area) => selectedAreas.includes(area.id))
          .map((area) => area.department.id),
      ),
    );
    selectedBusinessUnits = Array.from(
      new Set(
        departments
          .filter((department) => selectedDepartments.includes(department.id))
          .map((department) => department.business_unit.id),
      ),
    );
  }

  function applyProjectPrefill() {
    if (projectPrefillApplied) return;
    projectPrefillApplied = true;
    const requestedNames = prefilledDepartments.map((department) =>
      String(department.name ?? department)
        .trim()
        .toLocaleLowerCase(),
    );
    const requestedIds = prefilledDepartments
      .map((department) => department.id)
      .filter(Boolean);
    const matchingDepartments = departments.filter(
      (department) =>
        requestedIds.includes(department.id) ||
        requestedNames.includes(department.text.trim().toLocaleLowerCase()),
    );
    selectedDepartments = matchingDepartments.map(
      (department) => department.id,
    );
    selectedBusinessUnits = Array.from(
      new Set(
        matchingDepartments.map((department) => department.business_unit.id),
      ),
    );
    if (prefilledProjectName) settings.surveyName = prefilledProjectName;
    setSelectedItems(step, areaStep);
  }

  async function updatePresets() {
    await Promise.all([
      getTasks(),
      getAreas(),
      getDepartments(),
      getBusinessUnits(),
    ]);

    setMultiselectItems(step);
  }

  function getTasks() {
    return fetchWithSession("/api/knextractor/tasks")
      .then((response) => response.json())
      .then((data) => {
        tasks = data.map((item) => ({
          id: item.id,
          text: item.name,
          area: item.area,
          surveys: item.surveys,
        }));
      });
  }
  function getDepartments() {
    return fetchWithSession("/api/knextractor/departments")
      .then((response) => response.json())
      .then((data) => {
        departments = data.map((item) => ({
          id: item.id,
          text: item.name,
          business_unit: item.business_unit,
          areas: item.areas,
          users: item.users,
        }));
      });
  }

  function getAreas() {
    return fetchWithSession("/api/knextractor/areas")
      .then((response) => response.json())
      .then((data) => {
        areas = data.map((item) => ({
          id: item.id,
          text: item.name,
          department: item.department,
          tasks: item.tasks,
        }));
      });
  }
  function getBusinessUnits() {
    return fetchWithSession("/api/knextractor/business-units")
      .then((response) => response.json())
      .then((data) => {
        businessUnits = data.map((item) => ({
          id: item.id,
          text: item.name,
          departments: item.departments,
        }));
      });
  }
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function addSelectedKpis(event) {
    const selectedIds = event.detail?.selectedIds || [];
    if (!selectedIds.length) return;
    settings.objective = Array.from(
      new Set([...settings.objective, ...selectedIds]),
    );
    settings = { ...settings };
    kpiDropdownSelection = [];
  }

  function removeKpi(id) {
    settings.objective = settings.objective.filter(
      (objectiveId) => objectiveId !== id,
    );
    settings = { ...settings };
  }

  function getObjectives() {
    fetchWithSession("/api/knextractor/questions")
      .then((response) => response.json())
      .then((data) => {
        objectives = data.map((item) => ({
          id: item.id,
          text: item.title,
        }));
      });
  }
  onMount(() => {
    getObjectives();
    updatePresets();
  });
</script>

<Header
  section="Digital Twin"
  projectNameOverride={edit
    ? settings.surveyName
    : prefilledProjectName || "Digital Twin"}
  hideProjectName={!edit}
  projectHref={ROUTES.dam.root}
  area="Potential Scout"
  areaClickable={false}
  breadcrumb={sectionMode
    ? sectionBreadcrumb
    : step === 4
      ? titles[step].head +
        " " +
        businessUnits.find((a) => a.id === selectedBusinessUnits[areaStep])
          ?.text
      : edit
        ? "Edit Survey"
        : "New Survey"}
/>

<div class="maincontainer">
  <div class="canvas {step === 5 ? 'settings' : ''}">
    {#if loadingSurvey}
      <Loading></Loading>
    {:else}
      <div class="survey_status">
        <div class="tile" class:settings_intro={step === 5}>
          <div class="tile_header">
            {#if step === 4}
              <h5>
                {titles[step].title}
                {businessUnits.find(
                  (a) => a.id === selectedBusinessUnits[areaStep],
                )?.text}
              </h5>
            {:else}
              <h5>{titles[step].title}</h5>
            {/if}
            <span>
              {sectionMode
                ? section === "scope"
                  ? `Step ${step + 1} of 4`
                  : section === "participants" &&
                      selectedBusinessUnits.length > 1
                    ? `Business unit ${areaStep + 1} of ${selectedBusinessUnits.length}`
                    : sectionBreadcrumb
                : `Step ${step + 1} of ${totalSteps + 1}`}
            </span>
          </div>
          <p>{titles[step].subtitle}</p>
        </div>
        {#if step >= 0 && step <= 3}
          {#key { step, multiselectItems }}
            {#if step === 0}
              <div class="multiselect_wrapper">
                <Select
                  hideLabel
                  filterable
                  placeholder={`Select one ${titles[step].type}`}
                  bind:selected={selectedItems[0]}
                  on:change={() => {
                    selectedItems = [...selectedItems];
                  }}
                  labelText="Select {titles[step].type}"
                >
                  {#each multiselectItems as selectItem}
                    <SelectItem value={selectItem.id} text={selectItem.text}
                    ></SelectItem>
                  {/each}
                  </Select>
              </div>
            {:else}
              <div class="multiselect_wrapper">
                <MultiSelect
                  filterable
                  placeholder={`Select ${titles[step].type}s `}
                  bind:selectedIds={selectedItems}
                  label="Select {titles[step].type}s "
                  items={multiselectItems}
                  sortItem={() => {}}
                ></MultiSelect>
              </div>
            {/if}
          {/key}
          <div class="options_wrapper">
            {#each options as option}
              {#if option.id}
                <div class="option">
                  {option.text || option.email}
                  <Button
                    size="small"
                    kind="danger"
                    icon={TRASH_ICON}
                    on:click={() => {
                      openOptionDangerModal = true;
                      selectedOption = option.id;
                    }}
                    iconDescription="Delete"
                  />
                </div>
              {/if}
            {/each}
          </div>
        {:else if step === 4}
          <div class="users_mail_table">
            <DataTable
              batchSelection
              bind:selectedRowIds={selectedUsersIds}
              class="custom-table"
              headers={baseHeaders}
              rows={usersFiltered}
              sortable
            >
              <Toolbar>
                <ToolbarContent>
                  <ToolbarSearch bind:value={tableFilter} persistent />
                  <div class="department_filter">
                    <MultiSelect
                      hideLabel
                      titleText="Departments"
                      label={selectedDepartmentFilters.length
                        ? `${selectedDepartmentFilters.length} department${selectedDepartmentFilters.length === 1 ? "" : "s"}`
                        : "All departments"}
                      items={departmentFilterOptions}
                      bind:selectedIds={selectedDepartmentFilters}
                      sortItem={() => {}}
                    />
                  </div>
                </ToolbarContent>
              </Toolbar>
              <svelte:fragment slot="cell" let:row let:cell>
                {#if cell.key === "department"}
                  {cell.value.name}
                {:else}
                  {cell?.value || "-"}
                {/if}
              </svelte:fragment>
            </DataTable>
          </div>
        {/if}
        {#if step >= 0 && step <= 4}
          <div class="option add_new">
            <Button
              large
              kind="secondary"
              icon={PLUS_ICON}
              iconRight
              on:click={() => {
                setSelectModalOptions();
                openModalNew = true;
              }}
              iconDescription="Add new"
              text="Add new"
            />
          </div>
        {:else if step === 5}
          <div class="setting_wrapper">
            <div class="option">
              <div class="field_name">Survey Name</div>
              <div class="survey_name_wrapper">
                <div>
                  {settings.surveyName}
                </div>
                <Button
                  size="small"
                  kind="secondary"
                  icon={EDIT_ICON}
                  on:click={() => {
                    newValue = settings.surveyName;
                    openModalNew = true;
                  }}
                  iconDescription="Edit"
                />
              </div>
            </div>
            <div class="option">
              <div class="field_name">Start of survey</div>
              <div class="time_selector">
                <DatePicker
                  bind:value={settings.startDate}
                  datePickerType="single"
                  dateFormat="d-m-Y"
                >
                  <DatePickerInput
                    invalid={invalidDates}
                    hidelabel
                    id="date-picker-input-id"
                    placeholder="m-d-y"
                  />
                </DatePicker>
                <!-- <TimePicker hideLabel bind:value={settings.startTime}
                ></TimePicker> -->
              </div>
            </div>
            <div class="option">
              <div class="field_name">End of survey</div>
              <div class="time_selector">
                <DatePicker
                  bind:value={settings.endDate}
                  datePickerType="single"
                  dateFormat="d-m-Y"
                >
                  <DatePickerInput
                    invalid={invalidDates}
                    hidelabel
                    id="date-picker-input-id-end"
                    placeholder="d-m-y"
                  />
                </DatePicker>
                <!-- <TimePicker bind:value={settings.endTime} hideLabel
                ></TimePicker> -->
              </div>
            </div>
            <div class="option">
              <div class="field_name">First reminder</div>
              <div class="reminder_wrapper">
                <Checkbox bind:checked={enableFirstReminder}></Checkbox>
                <NumberInput
                  allowEmpty={!enableFirstReminder}
                  hideSteppers
                  hideLabel
                  disabled={!enableFirstReminder}
                  min="0"
                  max="99"
                  bind:value={settings.reminder_days}
                ></NumberInput> days before deadline

                <!-- <MultiSelect
                  bind:selectedIds={settings.reminder}
                  label={settings.reminder.join(", ") || "Select reminder..."}
                  items={reminderOptions}
                ></MultiSelect> -->
                <!-- <Select bind:selected={settings.reminder}>
                  <SelectItem value="1" />
                  <SelectItem value="5" />
                  <SelectItem value="10" />
                </Select> -->
              </div>
            </div>
            <div class="option">
              <div class="field_name">Second reminder</div>
              <div class="reminder_wrapper">
                <Checkbox bind:checked={enableSecondReminder}></Checkbox>
                <NumberInput
                  allowEmpty={!enableSecondReminder}
                  hideSteppers
                  hideLabel
                  disabled={!enableSecondReminder}
                  min="0"
                  max="99"
                  bind:value={settings.reminder2_days}
                ></NumberInput> days before deadline
              </div>
            </div>
            <div class="option">
              <div class="field_name">Included KPIs</div>
              <div class="kpi_selection_wrapper">
                <div class="kpi_tags">
                  {#each selectedObjectives as objective (objective.id)}
                    <button
                      type="button"
                      class="kpi_tag"
                      title="Remove {objective.text}"
                      aria-label="Remove {objective.text}"
                      on:click={() => removeKpi(objective.id)}
                    >
                      <span>{objective.text}</span>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  {/each}
                </div>
                <MultiSelect
                  titleText="KPIs"
                  label={availableObjectives.length
                    ? "Add KPIs..."
                    : "All KPIs selected"}
                  hideLabel
                  disabled={availableObjectives.length === 0}
                  bind:selectedIds={kpiDropdownSelection}
                  items={availableObjectives}
                  sortItem={() => {}}
                  on:select={addSelectedKpis}
                ></MultiSelect>
              </div>
            </div>
            <div class="option">
              <div class="field_name">Language</div>
              <div>
                <Select hideLabel bind:selected={settings.language}>
                  <SelectItem value="en" text="English (ENG)" />
                  <SelectItem value="de" text="Deutsch (GER)" />
                  <SelectItem value="es" text="Español (SPA)" />
                  <SelectItem value="it" text="Italiano (ITA)" />
                </Select>
              </div>
            </div>
            <div class="option">
              <div class="field_name">Add contact person</div>
              <div>
                <Checkbox bind:checked={contactPerson}></Checkbox>
              </div>
            </div>
            {#if contactPerson}
              <div class="option">
                <div class="field_name">Contact person name</div>
                <div>
                  <TextInput
                    placeholder="Add contact person name"
                    bind:value={settings.contactPersonName}
                  ></TextInput>
                </div>
              </div>
              <div class="option">
                <div class="field_name">Contact person email</div>
                <div>
                  <TextInput
                    placeholder="Add contact person E-Mail"
                    invalid={settings.contactPersonEmail &&
                      !isValidEmail(settings.contactPersonEmail)}
                    bind:value={settings.contactPersonEmail}
                  ></TextInput>
                </div>
              </div>
            {/if}
            <div class="option signature_option">
              <div class="field_name">E-Mail Signature</div>
              <div>
                <TextArea
                  placeholder="Add email signature"
                  bind:value={settings.signature}
                ></TextArea>
              </div>
            </div>
          </div>
        {/if}
      </div>
      <div class="form_builder_footer">
        <div class="buttons_wrapper">
          <Button
            kind="secondary"
            text="Cancel"
            icon={CLOSE_ICON}
            iconLeft
            on:click={() => (openDangerModal = true)}
          />
          <div class="steps_buttons">
            {#if hasSectionPrevious}
              <Button
                text="Previous Step"
                icon={ARROW_LEFT_ICON}
                iconLeft
                on:click={() => {
                  if (section === "participants" && areaStep > 0)
                    areaStep = areaStep - 1;
                  else if (step === 4 && areaStep > 0) areaStep = areaStep - 1;
                  else step = step - 1;
                }}
              />
            {/if}
            {#if hasSectionNext}
              <Button
                text="Next Step"
                icon={ARROW_RIGHT_ICON}
                iconRight
                disabled={disableNext}
                on:click={() => {
                  if (disableNext) return;
                  if (step === 4 && areaStep < selectedBusinessUnits.length - 1)
                    areaStep = areaStep + 1;
                  else step = step + 1;
                }}
              />
            {/if}
            {#if sectionMode && !hasSectionNext}
              <Button
                text="Save and return"
                icon={CHECK_ICON}
                iconRight
                disabled={disableNext}
                on:click={() => {
                  if (!disableNext) saveSurvey(true);
                }}
              />
            {:else if step === totalSteps}
              <Button
                text="Confirm"
                icon={CHECK_ICON}
                iconRight
                on:click={() => {
                  saveSurvey();
                }}
              />
            {/if}
          </div>
        </div>
        {#if step === 4 && disableNext}
          <div class="disable_next">
            Please select at least 3 users per department
          </div>
        {/if}
        {#if step === 5 && disableNext}
          <div class="disable_next">
            {invalidSettingsText}
          </div>
        {/if}
      </div>
    {/if}
  </div>
</div>

<DangerModal
  preventCloseOnClickOutside
  danger
  bind:open={openDangerModal}
  modalHeading="Cancel"
  primaryButtonText="Confirm"
  secondaryButtonText="Cancel"
  on:submit={() => {
    if (sectionMode) window.location.assign(progressRoute());
    else navigate(ROUTES.dam.root);
  }}
  on:click:button--secondary={() => (openDangerModal = false)}
>
  <h5>Do you really want to cancel?</h5>
  <p>
    {sectionMode
      ? "Unsaved changes will be discarded."
      : "This cannot be undone"}
  </p>
</DangerModal>

<DangerModal
  danger
  bind:open={openOptionDangerModal}
  modalHeading="Delete selection"
  primaryButtonText="Confirm"
  secondaryButtonText="Cancel"
  on:submit={() => {
    selectedItems = selectedItems.filter((item) => item !== selectedOption);
    openOptionDangerModal = false;
  }}
  on:click:button--secondary={() => (openOptionDangerModal = false)}
>
  <h5>Do you really want to remove this selection?</h5>
</DangerModal>

<Modal
  modalHeading={step < 5
    ? `New ${step === 4 ? "user" : titles[step]?.type}`
    : "Survey name"}
  bind:open={openModalNew}
  actions
  preventCloseOnClickOutside
  autowidth
  primaryButtonText="Save"
  secondaryButtonText="Cancel"
  primaryButtonNotAllow={disableSave}
  on:close={() => {
    newValue = "";
  }}
  on:click:button--secondary={() => (openModalNew = false)}
  primaryButtonAction={() => {
    if (disableSave) return;
    if (step === 5) {
      settings.surveyName = newValue;
      openModalNew = false;
      newValue = "";
      return;
    } else if (
      step === 4 &&
      isValidEmail(newUser.email) &&
      newUser.first_name &&
      newUser.last_name
    ) {
      createNewUser();
      return;
    }
    newPreset();
  }}
>
  {#if step !== 4}
    <TextInput
      autocomplete="on"
      labelText="{capitalize(titles[step]?.type)} name"
      placeholder="Enter {step === 4 ? 'user' : titles[step]?.type} name"
      bind:value={newValue}
    />
    <br />
  {:else if step === 4}
    <TextInput
      autocomplete="on"
      labelText="First name"
      placeholder="Enter first name"
      bind:value={newUser.first_name}
    />
    <TextInput
      autocomplete="on"
      labelText="Last name"
      placeholder="Enter last name"
      bind:value={newUser.last_name}
    />
    <TextInput
      autocomplete="on"
      labelText="E-Mail"
      placeholder="Enter E-Mail"
      invalidText="Please enter a valid email address"
      invalid={!(isValidEmail(newUser.email) || !newUser.email)}
      bind:value={newUser.email}
    />
  {/if}
  {#if step > 0 && step < 5}
    {#key selectModalOptions}
      <Select
        bind:selected={upperLevel}
        labelText="Select {step === 4 ? 'department' : titles[step - 1]?.type}"
      >
        {#each selectModalOptions as select}
          <SelectItem value={select.id} text={select.text}></SelectItem>
        {/each}
      </Select>
    {/key}
  {/if}
</Modal>

<Modal
  bind:open={openSendModal}
  primaryButtonText="Back to Overview"
  secondaryButtons={[]}
  preventCloseOnClickOutside
  actions
  autowidth
  noSecondayButton
  modalHeading="Survey {edit ? 'Edited' : 'Created'}"
  primaryButtonAction={() => {
    openSendModal = false;
    navigate(ROUTES.dam.root);
  }}
  on:close={() => {
    navigate(ROUTES.dam.root);
  }}
>
  {#if edit}
    <p>Survey updated</p>
  {:else}
    <h5>Survey creation completed</h5>
    <p>invitations will be sent</p>
  {/if}
</Modal>

{#if openToast}
  <div
    in:fly={{ x: 100 }}
    out:fly={{ y: 100 }}
    style="position:absolute; top:20px; right:50px; z-index:100;"
  >
    <ToastNotification
      fullWidth
      kind="error"
      title="Error"
      subtitle={errorToastMessage}
      caption={new Date().toLocaleString()}
      on:close={(e) => {
        e.preventDefault();
        openToast = false;
      }}
    />
  </div>
{/if}

<style>
  .canvas {
    min-height: min(42rem, calc(100vh - 8rem));
    max-height: calc(100vh - 8rem);
    border-radius: 0.5rem;
    gap: 0.85rem;
    width: min(62rem, calc(100vw - 7rem));
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  .canvas:not(.settings) {
    overflow: hidden;
    overflow-x: hidden;
  }

  .canvas.settings {
    width: min(64rem, calc(100vw - 7rem));
  }

  .maincontainer {
    border-radius: 0.5rem;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .buttons_wrapper {
    border-radius: 0.5rem;
    min-height: 4rem;
    width: 100%;
    padding: 0.5rem 1rem;
    background-color: var(--pax-white);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  .tile {
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: var(--pax-orange);
    color: var(--pax-white);

    padding: 0.6rem 1rem;
    border-radius: 0.5rem;
    margin-bottom: 1rem;
  }

  .tile_header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
  }

  .tile_header h5 {
    margin: 0;
    min-width: 0;
  }

  .tile_header span {
    flex: 0 0 auto;
    border: 1px solid rgba(255, 255, 255, 0.65);
    border-radius: 999px;
    padding: 0.18rem 0.55rem;
    font-size: 0.72rem;
    line-height: 1.2;
    color: var(--pax-white);
  }

  .tile.settings_intro {
    background: transparent;
    color: var(--pax-black);
    border-radius: 0;
    border-left: 0.2rem solid var(--pax-orange);
    padding: 0.15rem 1.25rem;
    margin: 0 0 1.25rem;
  }

  .tile.settings_intro h5 {
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
  }

  .tile.settings_intro .tile_header span {
    border-color: #dfe3e8;
    color: #6f6f6f;
  }

  .tile.settings_intro p {
    color: #6f6f6f;
  }

  .survey_status {
    padding: 1rem;
    background-color: var(--pax-white);
    width: 100%;
    min-height: 0;
    overflow-y: auto;
    border-radius: 0.5rem;
  }

  .steps_buttons {
    display: flex;
    gap: 0.5rem;
  }
  .options_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-top: 1rem;
  }

  .option {
    background-color: var(--pax-smoke);
    min-height: 3rem;
    height: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    min-width: 0;
  }

  :global(.multiselect_wrapper .bx--list-box__menu) {
    left: auto !important;
    transform: none;
    z-index: 50;
    width: min(100%, 56rem);
    max-width: calc(100vw - 8rem);
  }

  /* .topic {
    width: 100%;
    aspect-ratio: 1;
    align-content: center;
    border: 2px solid var(--pax-black);
    border-radius: 0.5rem;
    text-align: center;
  }
  .topics_wrapper {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;
    padding-top: 1rem;
    width: 100%;
  } */
  .add_new {
    background-color: var(--pax-black);
    color: var(--pax-white);
    cursor: pointer;
    margin-top: 0.5rem;
  }
  .setting_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0;
    border: 1px solid #d9d9d9;
    border-radius: 0.5rem;
    overflow: visible;
  }

  .setting_wrapper .option {
    min-height: 4rem;
    height: auto;
    border-radius: 0;
    border-bottom: 1px solid #d9d9d9;
    background: var(--pax-white);
    align-items: flex-start;
    padding-top: 0.85rem;
    padding-bottom: 0.85rem;
  }

  .setting_wrapper .option:first-child {
    border-radius: 0.5rem 0.5rem 0 0;
  }

  .setting_wrapper .option:last-child {
    border-bottom: 0;
    border-radius: 0 0 0.5rem 0.5rem;
  }

  :global(.survey_status .setting_wrapper .option select),
  :global(
      .survey_status
        .setting_wrapper
        .option
        .bx--select-input
        .x--select-option
    ) {
    border: none !important;
  }

  :global(.survey_status .setting_wrapper .option .bx--select) {
    flex-direction: row;
  }

  :global(.survey_status .option.add_new .enlarge) {
    display: flex;
    justify-content: space-between;
    padding-left: 0rem;
    padding-right: 0.5rem;
  }

  .survey_name_wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    width: min(100%, 42rem);
    margin-left: auto;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .survey_name_wrapper div:first-child {
    max-width: 40rem;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .time_selector {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  :global(
      .survey_status
        .setting_wrapper
        .bx--date-picker.bx--date-picker--single
        .bx--date-picker__input
    ) {
    width: auto;
  }

  :global(.survey_status .setting_wrapper .bx--select-input) {
    text-align: center;
  }

  :global(.setting_wrapper .option .bx--multi-select__wrapper) {
    width: min(24rem, 100%);
  }

  .kpi_selection_wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    gap: 0.5rem;
    width: min(100%, 48rem);
    margin-left: auto;
  }

  .kpi_tags {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 0.375rem;
    min-width: 0;
  }

  .kpi_tag {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    min-height: 2rem;
    padding: 0.3rem 0.625rem;
    border: 1px solid var(--pax-black);
    border-radius: 999px;
    background: var(--pax-white);
    color: var(--pax-black);
    font: inherit;
    font-size: 0.75rem;
    line-height: 1.2;
    cursor: pointer;
  }

  .kpi_tag:hover,
  .kpi_tag:focus-visible {
    background: var(--pax-black);
    color: var(--pax-white);
  }

  :global(.kpi_selection_wrapper .bx--multi-select__wrapper) {
    flex: 0 0 18rem;
    width: 18rem !important;
    margin-left: auto;
  }

  :global(
      .setting_wrapper .option .bx--multi-select__wrapper .bx--list-box__label
    ) {
    width: 100%;
    text-overflow: ellipsis;
  }
  :global(.users_mail_table thead .bx--checkbox + .bx--checkbox-label::before),
  :global(
      .users_mail_table
        thead
        .bx--checkbox:checked
        + .bx--checkbox-label::before
    ),
  :global(
      .users_mail_table
        thead
        .bx--checkbox:indeterminate
        + .bx--checkbox-label::before
    ) {
    background-color: white;
  }
  :global(
      .users_mail_table thead .bx--checkbox:checked + .bx--checkbox-label::after
    ),
  :global(
      .users_mail_table
        thead
        .bx--checkbox:indeterminate
        + .bx--checkbox-label::after
    ) {
    border-bottom: 2px solid black;
  }
  :global(
      .users_mail_table thead .bx--checkbox:checked + .bx--checkbox-label::after
    ) {
    border-left: 2px solid black;
  }

  .disable_next {
    padding: 0 1rem 0.75rem;
    width: 100%;
    text-align: end;
    color: var(--pax-danger);
  }

  .reminder_wrapper {
    display: flex;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  :global(.reminder_wrapper .bx--number input[type="number"]) {
    min-width: 2rem;
    width: 3rem;
    padding-right: 0;
  }

  .form_builder_footer {
    background-color: var(--pax-white);
    border-radius: 0.5rem;
    flex: 0 0 auto;
  }

  .users_mail_table {
    min-height: 0;
    overflow: auto;
  }

  :global(.users_mail_table .bx--toolbar-content) {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
  }

  :global(.users_mail_table .bx--search) {
    flex: 1 1 auto;
    min-width: 0;
  }

  .department_filter {
    flex: 0 0 14rem;
    width: 14rem;
  }

  :global(.department_filter .bx--form-item),
  :global(.department_filter .bx--multi-select),
  :global(.department_filter .bx--list-box) {
    width: 100%;
  }

  .option.add_new {
    padding-left: 0;
    padding-right: 0;
  }

  .signature_option {
    height: auto;
  }

  :global(.form_builder_footer .buttons_wrapper .mainbutton:hover),
  :global(.survey_status > .option .mainbutton.secondary:hover) {
    background-color: var(--pax-orange) !important;
  }

  :global(.survey_status .option .mainbutton.secondary) {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  :global(
      .canvas
        .survey_status
        .multiselect_wrapper
        .bx--form-item
        .bx--select
        .bx--select-input__wrapper
        .select_first_option
    ) {
    color: var(--pax-grey);
    font-style: italic;
  }

  @media (max-width: 900px) {
    .canvas,
    .canvas.settings {
      width: min(100%, calc(100vw - 2rem));
      min-height: calc(100vh - 7rem);
      max-height: calc(100vh - 7rem);
    }

    .tile_header,
    .buttons_wrapper,
    .setting_wrapper .option {
      align-items: stretch;
      flex-direction: column;
    }

    .steps_buttons,
    .reminder_wrapper {
      justify-content: flex-start;
    }

    :global(.form_builder_footer .buttons_wrapper .mainbutton) {
      width: 100%;
    }
  }
</style>
